import { Language } from '../../../../../common/constants';

export class EndUserLicenseAgreementItemFileLoad {
  public static readonly type = '[EndUserLicenseAgreementItemFile] Load';

  constructor(public payload: string) {}
}

export class EndUserLicenseAgreementLastItemFileLoad {
  public static readonly type = '[EndUserLicenseAgreementLastItemFile] Load';

  constructor(public payload: { languageCode: Language }) {}
}

export class EndUserLicenseAgreementItemFileInitialState {
  public static readonly type = '[EndUserLicenseAgreementItemFile] Set Initial State';
}
